__turbopack_context__.v({
  "linkBtns": "page-module__aydn6q__linkBtns",
  "loginBackground": "page-module__aydn6q__loginBackground",
  "loginPage": "page-module__aydn6q__loginPage",
});
